"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gemini = void 0;
const services_1 = require("../services");
const stringify_1 = require("../utils/stringify");
const gemini = (config) => {
    return (mode, src, { width, height, quality = services_1.DEFAULT_IMG_QUALITY }) => {
        if (!(0, services_1.validateResizeOptions)(mode, { width, height }))
            return src;
        let resizeTo;
        switch (mode) {
            case "crop": {
                resizeTo = "fill";
                break;
            }
            case "resize": {
                if (width && !height) {
                    resizeTo = "width";
                    break;
                }
                if (height && !width) {
                    resizeTo = "height";
                    break;
                }
                resizeTo = "fit";
            }
        }
        const params = {
            height,
            resize_to: resizeTo,
            src,
            width,
            quality,
        };
        const query = (0, stringify_1.stringify)(params);
        return `${config.endpoint}?${query}`;
    };
};
exports.gemini = gemini;
